import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";

import DashboardIcon from "@mui/icons-material/Dashboard";
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import EmailIcon from '@mui/icons-material/Email';
import ViewListIcon from '@mui/icons-material/ViewList';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { DrawerHeader, Drawer } from "../common/utils";
import { Settings } from "@mui/icons-material";

const NavListItem = ({ label, Icon, Url, drawerOpen, theme }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (page) => () => {
    window.scrollTo(0, 0);
    navigate(page);
  };

  const isActive = location.pathname === Url;

  return (
    <ListItem disablePadding sx={{ display: "block" }}>
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: drawerOpen ? "initial" : "center",
          px: 2.5,
          bgcolor: isActive ? theme.palette.primary.main : theme.palette.background.paper,
          color: isActive ? theme.palette.primary.contrastText : theme.palette.text.primary,
          "&:hover": {
            bgcolor: isActive
              ? theme.palette.primary.dark
              : theme.palette.action.hover,
          },
        }}
        onClick={handleNav(Url)}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: drawerOpen ? 3 : "auto",
            justifyContent: "center",
            color: isActive
              ? theme.palette.primary.contrastText
              : theme.palette.text.secondary,
          }}
        >
          <Icon />
        </ListItemIcon>
        <ListItemText
          primary={label}
          sx={{ opacity: drawerOpen ? 1 : 0 }}
        />
      </ListItemButton>
    </ListItem>
  );
};

const DesktopNav = ({ drawerOpen, closeDrawer, theme, headerData }) => {
  const navItems = [
    { key: "dashboard", label: "Dashboard", Url: `/Portal/Dashboard`, Icon: DashboardIcon },
    { key: "createEmail", label: "Create Email", Url: `/Portal/Emails/Create`, Icon: ScheduleSendIcon },
    { key: "manageEmail", label: "Manage Emails", Url: `/Portal/Emails/Manage`, Icon: EmailIcon },
    { key: "addMailing", label: "Add to Mailing", Url: `/Portal/Mailing/Add`, Icon: LibraryAddIcon },
    { key: "mailingList", label: "Mailing List", Url: `/Portal/Mailing/Manage`, Icon: ViewListIcon },
    { key: "users", label: "Manage Users", Url: `/Portal/Users/Manage`, Icon: AccountCircleIcon },
    { key: "settings", label: "Settings", Url: `/Portal/Settings`, Icon: Settings },
  ];

  const capabilities = headerData?.capabilities || {};
  const filteredNavItems = navItems.filter(({ key }) => capabilities[key] !== false);

  return (
    <Drawer variant="permanent" open={drawerOpen}>
      <DrawerHeader>
        <IconButton onClick={closeDrawer}>
          {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <List>
        {filteredNavItems.map(({ key, label, Icon, Url }) => (
          <React.Fragment key={key}>
            <NavListItem
              label={label}
              Icon={Icon}
              Url={Url}
              drawerOpen={drawerOpen}
              theme={theme}
            />
            <Divider />
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
};

export default DesktopNav;
